import { render, staticRenderFns } from "./CartProductSummary.vue?vue&type=template&id=9db8cb48&scoped=true&lang=pug&"
import script from "./CartProductSummary.vue?vue&type=script&lang=js&"
export * from "./CartProductSummary.vue?vue&type=script&lang=js&"
import style0 from "./CartProductSummary.vue?vue&type=style&index=0&id=9db8cb48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db8cb48",
  null
  
)

export default component.exports